module.exports = __webpack_public_path__ + "img/20200609_114417.cad68c7f.jpg";